/* eslint-disable no-control-regex */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StringSearchService {
  removeDiacriticsThenLowerCase(input: string, lang: string): string {
    if (input) {
      return this.removeDiacritics(input, lang).toLocaleLowerCase(lang);
    }
    return input;
  }

  /**
   * Removes accents and other diacritics.
   * This uses a very clever trick from https://stackoverflow.com/a/47368424 :
   * String.prototype.normalize() is used to force decomposition of accentuated chars into
   * the "base" character followed by a combining diacritical mark;
   * from there a replace is used to get rid of the diacritical marks,
   * knowing that these marks are in the U+0300 - U+036F range ( https://en.wikipedia.org/wiki/Combining_Diacritical_Marks )
   */
  removeDiacritics(input: string, lang: string): string {
    if (input) {
      return input
        .normalize('NFC') // do "compact" any NFD-normalized diacritics (unlikely to run into that but for completeness' sake)
        .replace(/[^\u0000-\u007E]/g, letter => this.removeDiacriticsFromLetter(letter, lang));
    }
    return input;
  }

  private removeDiacriticsFromLetter(letter: string, lang: string): string {
    const letterWithoutDiacritics = letter.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return this.areEquivalent(letter, letterWithoutDiacritics, lang) ? letterWithoutDiacritics : letter;
  }

  private areEquivalent(letterA, letterB, lang) {
    return new Intl.Collator(lang, { usage: 'search', sensitivity: 'base' }).compare(letterA, letterB) === 0;
  }
}
